import * as React from 'react';
import { Carousel } from '@grandvisionhq/common';
import { BannerTooltip, Banner } from '@grandvisionhq/content';
import { compose } from '@grandvisionhq/utils';
import { withAnchor } from '../../hocs/with-anchor.js';
import '@swc/helpers';
import '@grandvisionhq/state';
import '@bloomreach/react-sdk';
import '../../context/configuration.js';
import '@bloomreach/spa-sdk';
import '@grandvisionhq/search';
import 'jsonpointer';
import '../../utils/http-client.js';
import { parseBloomreachImage } from '../../utils/parse-bloomreach-image.js';
import { useBloomreachLinks } from '../../hooks/use-bloomreach-links.js';
import '@grandvisionhq/lib-utils-html';
import '@grandvisionhq/graphql';
import '../../operations/mutations/signup-promotion.js';
import '../../operations/mutations/subscribe-newsletter.js';
import '../../operations/mutations/subscribe-newsletter-opt-in.js';
import '@grandvisionhq/svc-tealium/events';
import '../../hooks/use-breakpoint-visibility.js';
import { withBloomreachPageable } from '../../hocs/with-bloomreach-pageable.js';
import { withBreakpointVisibility } from '../../hocs/with-breakpoint-visibility.js';
import { withEditableContent } from '../../hocs/with-editable-content.js';

const CmsCarouselItem = withEditableContent(({ content  })=>{
    var ref;
    const [link] = useBloomreachLinks(content.links);
    const image = parseBloomreachImage(content.image);
    const tooltip = ((ref = content.tooltip) === null || ref === void 0 ? void 0 : ref.showTooltip) ? content.tooltip : undefined;
    if (!image) {
        return null;
    }
    // The tooltip is added here, instead of on the Banner itself.
    // Adding it to the Banner would make it disappear when the carousel item height
    // exceeds the maximum height on desktop (34vw).
    return /*#__PURE__*/ React.createElement(React.Fragment, null, tooltip && /*#__PURE__*/ React.createElement(BannerTooltip, {
        className: "carousel__item--tooltip",
        tooltip: tooltip
    }), /*#__PURE__*/ React.createElement(Banner, {
        image: image.original,
        mobileImage: image.mobile,
        link: link
    }));
});
const CmsCarousel = ({ content  })=>{
    return /*#__PURE__*/ React.createElement(Carousel, {
        hasPagination: true
    }, content.items.map((item)=>/*#__PURE__*/ React.createElement(CmsCarouselItem, {
            key: item.id,
            content: item
        })
    ));
};
var CmsCarousel$1 = compose(withBreakpointVisibility, withBloomreachPageable, withAnchor)(CmsCarousel);

export { CmsCarousel, CmsCarouselItem, CmsCarousel$1 as default };
//# sourceMappingURL=Carousel.js.map
